import styled from "styled-components";

export const Container = styled.div`
    padding: 10px;
`

export const FormMultifocalInfo = styled.div`
    display: flex;
    justify-content: space-between;
`